export enum SocialCallbackUrlEnum {
  line = '/web/user/auth/line/callback',
  twitter = '/web/user/auth/twitter/callback',
  'asp-ostiaries' = '',
  'email' = '',
  'id-pw' = '',
  google = '/web/user/auth/google/callback',
  zalo = '/web/user/auth/zalo/callback',
}
